import { render, staticRenderFns } from "./InvoiceDuplicateModal.vue?vue&type=template&id=67ec1055"
import script from "./InvoiceDuplicateModal.vue?vue&type=script&lang=js"
export * from "./InvoiceDuplicateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports